export const LOCK_TEXT = {
  CONFIRM_LOCK_USER: `This user will immediately lose access to the portal. Their data
      will not be deleted and their accounts can be reactivated at any time`,
  CONFIRM_UNLOCK_USER: `This user will have the access to the portal again`,
  CONFIRM_LOCK_CLIENT: `All users under this client account will immediately lose access to the portal. Their data will not be deleted and their accounts can be reactivated at any time`,
} as const satisfies Record<string, string>;

export type LockTextKey = keyof typeof LOCK_TEXT;
